// frontend/src/utils/branding.js
//
// Single source of truth for the school name across the app.
// Caches in localStorage so the sidebar shows the correct name
// instantly on reload — before any network call resolves.

export const SCHOOL_NAME_KEY = 'schoolsphere_school_name';
export const SCHOOL_NAME_EVENT = 'school-name-updated';

export function getCachedSchoolName() {
  return localStorage.getItem(SCHOOL_NAME_KEY) || 'SchoolSphere';
}

export function setCachedSchoolName(name) {
  if (!name) return;
  localStorage.setItem(SCHOOL_NAME_KEY, name);
  document.title = name;
  window.dispatchEvent(new Event(SCHOOL_NAME_EVENT));
}